<!-- 由 suu 创建于 2019-08-29 星期四 -->
<template>
  <div class="nearby-shop-group">
    <img
      v-if="showMask"
      @click="showMask = false"
      class="forward-img"
      src="@/assets/imgs/WechatIMG14.png"
      alt="点击右上角转发给会员"
    />
    <div class="content" v-if="coachs.length > 0">
      <van-swipe
        @change="handleChange"
        :showIndicators="true"
        :auto="0"
        :defaultIndex="0"
        :speed="200"
      >
        <van-swipe-item v-for="(evaluate, index) in coachs" :key="index">
          <div class="new-top-content">
            <div class="new-info">
              <img class="new-head" :src="evaluate.image" />
              <div class="new-name">{{ evaluate.name }}</div>
              <div v-if="Number(evaluate.ordered)" class="ordered">
                已预约：{{ evaluate.ordered }}次
              </div>
              <div class="new-time">
                擅长领域：{{
                  evaluate.feature && evaluate.feature.replace(/\//g, ' ')
                }}
              </div>
            </div>
            <div class="new-rate">
              <span class="text">教练好评度</span>
              <van-rate
                class="on-rate"
                v-model="evaluate.score * 1"
                allow-half
                size="16"
                void-icon="star"
                color="#fed400"
                void-color="#ddd"
              />
              <span class="num">{{ evaluate.score }}分</span>
            </div>
            <div class="new-rate new-co">
              <span class="text">好评关键词</span>
              <div class="new-comment">
                <div v-if="evaluate.tages[0]">
                  <span>TOP1</span>
                  {{ evaluate.tages[0] }}
                </div>
                <div v-if="evaluate.tages[1]">
                  <span>TOP2</span>
                  {{ evaluate.tages[1] }}
                </div>
                <div v-if="evaluate.tages[2]">
                  <span>TOP3</span>
                  {{ evaluate.tages[2] }}
                </div>
              </div>
            </div>
            <div class="class-btn user-btn" @click="onClass(evaluate.id)">
              立即预约
            </div>
            <!-- <div
              class="share-btn user-btn"
              @click="setShare(evaluate.image, evaluate.id)"
            >
              推荐教练>
            </div> -->
          </div>
        </van-swipe-item>
      </van-swipe>
    </div>
    <!-- <div class="no-list" v-else>该地区没有可约课门店，试试其他地区吧~</div> -->
    <div :class="{ right: curIndex < coachs.length - 1 }"></div>
    <div :class="{ left: curIndex > 0 }"></div>
  </div>
</template>

<script>
export default {
  name: 'nearby-shop-group',

  components: {},

  props: {},

  data() {
    return {
      showMask: false,
      shopid: this.$route.query.shopid,
      curIndex: 0,
      coachs: []
    }
  },

  computed: {
    user() {
      return this.$store.state.user.user
    }
  },

  watch: {},

  created() {
    this.getCoachCase()
  },

  mounted() {},

  destroyed() {},

  methods: {
    getCoachCase() {
      this.$toast.loading('加载中')
      this.$http
        .get(
          'member/index?a=getShopCoach',
          {
            sid: this.shopid || ''
          },
          true
        )
        .then((res) => {
          console.log(res, 'getCoachCase')
          if (res.data.code === 200) {
            this.coachs = res.data.data
          }
          this.$toast.clear()
        })
        .catch((err) => {
          this.$$dialog.alert({ message: '网络错误请刷新重进' })
          this.$toast.clear()
        })
    },
    handleChange(index) {
      this.curIndex = index
    },
    getCurDay() {
      const week = ['日', '一', '二', '三', '四', '五', '六']
      const date = new Date()
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1)[1]
        ? String(date.getMonth() + 1)
        : '0' + String(date.getMonth() + 1)
      const day = String(date.getDate())[1]
        ? String(date.getDate())
        : '0' + String(date.getDate())
      let obj = {
        a_day: year + '-' + month + '-' + day,
        day: date.getMonth() + 1 + '-' + date.getDate(),
        week: week[date.getDay()]
      }
      return obj
    },
    onClass(cid) {
      let detailData = {}
      let currDay = this.getCurDay()
      let home = this.$store.state.subscribe.home
      let dayData = home[currDay.a_day]
      for (const key in dayData) {
        if (dayData.hasOwnProperty(key)) {
          const ele = dayData[key]
          if (ele['c_' + cid]) {
            detailData = ele['c_' + cid]
            break
          }
        }
      }
      if (Object.keys(detailData).length > 0) {
        this.$store.commit('setDetailData', detailData)
        this.$store.commit('setCurrDay', currDay)
        this.$router.push({
          path: '/subscribe/detail'
        })
      } else {
        this.$toast('该教练今日没有排课，换个试试吧~')
      }
    },
    setShare(img, cid) {
      let locaUser = localStorage.getItem('user')
      let uid = this.user.uid
      // console.log("locaUser", JSON.parse(locaUser), uid);
      if (!uid && locaUser) {
        uid = JSON.parse(locaUser).data.data.uid
      }
      this['$http'].share({
        title: `${
          this.user.truename ? this.user.truename : '你的朋友'
        }向您推荐靠谱教练，点击查看该教练的私教案例~`,
        desc: '量身定制科学化健身方案，打造更懂你的私教课，避免低效运动',
        imgUrl: img,
        link:
          location.href.split('#')[0] +
          `?path=coachcase&fid=${
            Number(uid === -1) ? this.$route.query.uid : uid
          }&cid=${cid}&fname=${encodeURIComponent(
            this.$route.query.fname
              ? this.$route.query.fname
              : this.user.truename || JSON.parse(locaUser).data.data.truename
          )}`
      })
      this.showMask = true
    }
  }
}
</script>

<style lang="scss" scoped>
@function vw($px) {
  @return ($px / 750) * 100vw;
}
@function rem($px) {
  @return ($px / 375) * 100vw;
}
.nearby-shop-group {
  // z-index: 11;
  width: 100vw;
  min-height: 100vh;
  position: relative;
  // display: flex;
  // flex-direction: column;
  // align-items: center;
  background-color: #f5f5f5;
  padding-top: vw(32);
  box-sizing: border-box;
  overflow: hidden;
  .no-list {
    text-align: center;
    margin-top: vw(20);
    color: #4a4a4a;
    font-size: vw(15);
    background-color: #f6f6f6;
  }
  .forward-img {
    width: vw(750);
    height: vw(544);
    position: fixed;
    top: vw(30);
    z-index: 999;
    left: 0;
  }
  .right {
    width: vw(46);
    height: vw(1129);
    background-color: #ffffff;
    box-shadow: vw(0) vw(3) vw(14) vw(0) rgba(0, 0, 0, 0.12);
    border-radius: vw(12);
    position: absolute;
    right: vw(-15);
    top: vw(32);
  }
  .left {
    width: vw(46);
    height: vw(1129);
    background-color: #ffffff;
    box-shadow: vw(0) vw(3) vw(14) vw(0) rgba(0, 0, 0, 0.12);
    border-radius: vw(12);
    position: absolute;
    top: vw(32);
    left: vw(-15);
  }
  .content {
    width: 100%;
    box-sizing: border-box;
    .new-top-content {
      width: 100%;
      background-color: #fff;
      border-radius: rem(35/2) rem(35/2) 0px 0px;
      // padding-top: rem(50/2);
      box-sizing: border-box;
      margin-top: vw(70);
      // padding-bottom: rem(10);
    }
    .new-info {
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;
      padding: 0 rem(30);
      padding-left: rem(72/2);
      box-sizing: border-box;
      // margin-top: rem(42);
      .new-head {
        width: vw(228);
        height: vw(228);
        border-radius: 50%;
        border: vw(20) solid #edeef0;
        // margin-right: rem(12);
      }
      .new-name {
        color: #000;
        font-size: vw(58);
        // font-weight: 500;
        margin-bottom: rem(3);
        margin-top: vw(12);
      }
      .ordered {
        font-size: vw(28);
        color: #4a4a4a;
      }
      .new-time {
        font-size: vw(26);
        color: #333;
        margin-bottom: rem(5);
        margin-top: vw(2);
      }
      .new-tips {
        font-size: rem(10);
        color: #dc0050;
        background-color: #fcdbe5;
        // width: rem(93);
        padding: 0 rem(5);
        border-radius: 44px 44px 44px 0;
        text-align: left;
      }
    }
    .new-rate {
      display: flex;
      align-items: center;
      width: 100%;
      padding: 0 rem(30);
      // padding-right: rem(20);
      padding-left: rem(72/2);
      box-sizing: border-box;
      margin-top: vw(44);
      .text {
        font-size: rem(12);
        font-weight: 600;
        color: #bbb;
        margin-right: rem(12);
      }
      .num {
        // margin-left: rem(5);
        font-size: rem(14);
        color: #dc0050;
      }
    }
    .new-co {
      align-items: stretch;
      margin-top: rem(11);
      .new-comment {
        flex: 1;
        display: flex;
        flex-direction: column;
        flex-wrap: wrap;
        font-size: rem(13);
        font-weight: 400;
        color: #333;
        // justify-content: space-between;
        align-items: flex-start;
        div {
          margin-bottom: rem(8);
          display: flex;
          align-items: center;
        }
        span {
          background-color: #f89500;
          border-radius: rem(2);
          font-size: rem(10);
          // font-weight: 500;
          color: #fff;
          font-weight: 600;
          padding: 0 rem(3);
          margin-right: rem(8);
        }
      }
    }
    .share-btn {
      margin-top: vw(16);
      color: #4a4a4a;
      font-size: vw(24);
    }
    .class-btn {
      width: vw(224);
      height: vw(60);
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: vw(26);
      color: #fff;
      background-color: #dc0050;
      border-radius: vw(8);
      margin: 0 auto;
      margin-top: vw(114);
      font-weight: 450;
    }
  }
  .van-swipe {
    margin: 0 auto;
    background-color: #fff;
    box-shadow: 0px 3px 14px 0px rgba(0, 0, 0, 0.12);
    border-radius: 12px;
    width: vw(644);
    // min-height: vw(539) !important;
    // min-height: vw(539);
    height: vw(1130);
    // margin-top: vw(74);
    z-index: 88;
    position: relative;
    .van-swipe-item {
      // min-height: vw(539) !important;
      height: vw(1130);
      width: vw(644);
      .is-on {
        font-size: vw(30);
        color: #3e4047;
        margin-top: vw(70);
        margin-bottom: vw(16);
      }
      .title,
      .desc {
        font-size: vw(24);
        color: #999;
        margin-bottom: vw(8);
      }
      .swipe-img {
        width: vw(286);
        height: vw(286);
      }
    }
  }
  ::v-deep {
    .van-swipe__indicator {
      width: vw(10) !important;
      height: vw(10) !important;
      border-radius: 50% !important;
      opacity: 1 !important;
      background-color: #eee !important;
    }
    .van-swipe__indicator.van-swipe__indicator--active {
      background-color: #999 !important;
    }
    .van-rate .van-rate__item {
      margin-right: vw(15);
      font-size: vw(36);
    }
  }
}
</style>
